import { render, staticRenderFns } from "./ActivityComments.vue?vue&type=template&id=7a9cf4d3&scoped=true&"
import script from "./ActivityComments.vue?vue&type=script&lang=js&"
export * from "./ActivityComments.vue?vue&type=script&lang=js&"
import style0 from "./ActivityComments.vue?vue&type=style&index=0&id=7a9cf4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9cf4d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a9cf4d3')) {
      api.createRecord('7a9cf4d3', component.options)
    } else {
      api.reload('7a9cf4d3', component.options)
    }
    module.hot.accept("./ActivityComments.vue?vue&type=template&id=7a9cf4d3&scoped=true&", function () {
      api.rerender('7a9cf4d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityComments.vue"
export default component.exports